import Glide from './glide.esm.js'

(() => {

  const glideEl = document.querySelector('.glide--slider-1')
  const sectionId = glideEl.dataset.glideSlider

  new Glide(`.glide--slider-${sectionId}`, {
    type: 'carousel',
    focusAt: 'center',
    perView: 1,
    perTouch: 1,
    gap: '40px',
    breakpoints: {
      749: {
        perView: 1,
        focusAt: 'center',
        gap: '5px',
      }
    }
  }).mount();

})()